import examesServices from "@/api/exames/examesServices";

export default {
  generate({ commit }, data) {
    return examesServices
      .generate(data)
      .then((result) => result)
      .catch((error) => error);
  },
  updateExame({ commit }, data) {
    return examesServices
      .updateExame(data)
      .then((result) => result)
      .catch((error) => error);
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) =>
      examesServices
        .getById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err)),
    );
  },
  getPatientById({ commit }, id) {
    return new Promise((resolve, reject) =>
      examesServices
        .getPatientById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err)),
    );
  },
  addExames({ commit }, data) {
    return examesServices
      .addExames(data)
      .then((result) => result)
      .catch((error) => error);
  },
  combosExames({ commit }) {
    return examesServices
      .combosExames()
      .then((result) => result)
      .catch((error) => error);
  },
  delete({ commit }, id) {
    return examesServices
      .delete(id)
      .then((result) => result)
      .catch((error) => error);
  },
  editObservacao({ commit }, data) {
    return examesServices
      .editObservacao(data)
      .then((result) => result)
      .catch((error) => error);
  },
};
